export default __webpack_public_path__ + "static/media/9.aeb4520e.svg";